import {useState, useEffect} from 'react';
import ProductList from '../../components/ProductList';
import {FULL_PRODUCTS}from '../../data/Products';

function ProductsContainer(){
    const [products, setProducts] = useState([]);
    useEffect(() => {
        setProducts(FULL_PRODUCTS);
    }, []);

    return <main className="home-container">
        <ProductList title="Productos" items={products} path="productos"/>
    </main>
}

export default ProductsContainer;